import { Checkbox } from '@ooh/ui/components/checkbox';
import { Label } from '@ooh/ui/components/label';

export interface MarkRestUnavailableCheckboxLabels {
  checkboxLabel: string;
  /** Template with {count} and {supplier} placeholders. */
  noteTemplate: string;
}

export interface MarkRestUnavailableCheckboxProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  supplierName: string;
  /** Mock/estimated count of other units this would affect. */
  count: number;
  labels: MarkRestUnavailableCheckboxLabels;
  testId?: string;
}

function formatNote(template: string, count: number, supplier: string): string {
  return template.replace('{count}', String(count)).replace('{supplier}', supplier);
}

/**
 * Optional "mark the rest of this supplier's units as unavailable too"
 * choice — only meaningful for the whole-file-is-a-free-list resolution
 * shape (no explicit per-row status column to fall back on).
 */
export function MarkRestUnavailableCheckbox({
  checked,
  onCheckedChange,
  supplierName,
  count,
  labels,
  testId = 'mark-rest-unavailable',
}: MarkRestUnavailableCheckboxProps) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-2">
        <Checkbox
          id={testId}
          checked={checked}
          onCheckedChange={(next) => onCheckedChange(next === true)}
          data-testid={testId}
        />
        <Label htmlFor={testId} className="font-normal text-foreground cursor-pointer">
          {labels.checkboxLabel}
        </Label>
      </div>
      {checked ? (
        <p className="text-xs text-muted-foreground pl-6" data-testid={`${testId}-note`}>
          {formatNote(labels.noteTemplate, count, supplierName)}
        </p>
      ) : null}
    </div>
  );
}
